import { render, staticRenderFns } from "./pic_cloud.vue?vue&type=template&id=20aa673a&scoped=true"
import script from "./pic_cloud.vue?vue&type=script&lang=js"
export * from "./pic_cloud.vue?vue&type=script&lang=js"
import style0 from "./pic_cloud.vue?vue&type=style&index=0&id=20aa673a&prod&scoped=true&lang=css"
import style1 from "./pic_cloud.vue?vue&type=style&index=1&id=20aa673a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aa673a",
  null
  
)

export default component.exports